import { render, staticRenderFns } from "./LiveStagePathForm.vue?vue&type=template&id=c516a542"
import script from "./LiveStagePathForm.vue?vue&type=script&lang=js"
export * from "./LiveStagePathForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports